export const json = {
  title: "SmartBEA Onboarding",
  description:
    "Different types of AC systems consume energy at different rates. By knowing what's installed in your property, we're better able to forecast demand.",
  logo: "https://api.surveyjs.io/private/Surveys/files?name=8368054e-198e-4448-8565-7eef6960f98e",
  logoPosition: "right",
  completedHtml: "<h3>Thanks! We will set up your dashboard and email you once it's ready!</h3>",
  pages: [
    {
      name: "eula",
      elements: [
        {
          type: "html",
          name: "question2",
          html: '<div style="font-weight:bold; font-size:1.2em; color:#d32f2f;">Please review our <a href="https://s3.ap-southeast-1.amazonaws.com/storage-prod.sensorflow.cloud/smartbea/SmartBEA+simple+EULA.pdf" style="text-decoration:underline;" target="_blank" rel="noopener noreferrer"><b>End User License Agreement (EULA)</b></a> before continuing.</div>\n',
        },
        {
          type: "checkbox",
          name: "eula_agreement",
          title: "I have read and agree to the End User License Agreement (EULA).",
          isRequired: true,
          choices: [
            {
              value: "true",
              text: "I have read and agree to the End User License Agreement.",
            },
          ],
        },
        {
          type: "html",
          name: "trust_center",
          html: '<div style="font-size:0.95em; color:#555; margin-top:10px;">Learn more about our security and privacy practices at our <a href="https://sensorflow.trust.site/" style="text-decoration:underline; color:#1976d2;" target="_blank" rel="noopener noreferrer">Trust Center</a>.</div>',
        },
      ],
    },
    {
      name: "page1",
      elements: [
        {
          type: "multipletext",
          name: "name",
          title: "Who are you?",
          description: "First Name",
          isRequired: true,
          items: [
            {
              name: "text1",
              title: "First Name",
            },
            {
              name: "text2",
              title: "Last Name",
            },
          ],
        },
      ],
    },
    {
      name: "page2",
      elements: [
        {
          type: "text",
          name: "company_role",
          title: "What's your role?",
          isRequired: true,
        },
      ],
    },
    {
      name: "page3",
      elements: [
        {
          type: "text",
          name: "phone_number",
          title: "Phone number\n",
          description: "Don't worry we won't share this with anyone else.",
          isRequired: true,
          inputType: "tel",
        },
      ],
    },
    {
      name: "page4",
      elements: [
        {
          type: "text",
          name: "email",
          title: "Email address",
          description: "We need this for account verification and to keep you updated with any new features.",
          isRequired: true,
          validators: [
            {
              type: "email",
              text: "Please enter a valid email address",
            },
            {
              type: "regex",
              regex: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+$",
              text: "Email must have the correct format",
            },
          ],
          inputType: "email",
        },
      ],
    },
    {
      name: "page5",
      elements: [
        {
          type: "text",
          name: "location_name",
          title: "Property Name",
          description: "What would we search for to find your property on Google?",
          isRequired: true,
        },
      ],
    },
    {
      name: "page6",
      title: "\n",
      description:
        "What is your property building address? We need to know exactly where you are to ensure we pull in the correct data for your insights.",
      elements: [
        {
          type: "text",
          name: "address_1",
          title: "Address line 1",
          isRequired: true,
        },
        {
          type: "text",
          name: "address_2",
          title: "Address line 2",
        },
        {
          type: "text",
          name: "city",
          title: "City/ Town",
          isRequired: true,
        },
        {
          type: "text",
          name: "state",
          title: "State/ Region/ Province",
          isRequired: true,
        },
        {
          type: "text",
          name: "zip_code",
          title: "ZIP/ Post code",
          isRequired: true,
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
            {
              type: "regex",
              regex: "^\\d{2,}$",
              text: "ZIP code must have at least 2 digits",
            },
          ],
        },
        {
          type: "dropdown",
          name: "country",
          title: "Country",
          isRequired: true,
          choices: [
            "Afghanistan",
            "Albania",
            "Algeria",
            "Andorra",
            "Angola",
            "Antigua and Barbuda",
            "Argentina",
            "Armenia",
            "Australia",
            "Austria",
            "Azerbaijan",
            "Bahamas",
            "Bahrain",
            "Bangladesh",
            "Barbados",
            "Belarus",
            "Belgium",
            "Belize",
            "Benin",
            "Bhutan",
            "Bolivia",
            "Bosnia and Herzegovina",
            "Botswana",
            "Brazil",
            "Brunei",
            "Bulgaria",
            "Burkina Faso",
            "Burundi",
            "Cabo Verde",
            "Cambodia",
            "Cameroon",
            "Canada",
            "Central African Republic",
            "Chad",
            "Chile",
            "China",
            "Colombia",
            "Comoros",
            "Congo, Democratic Republic of the",
            "Congo, Republic of the",
            "Costa Rica",
            "Cote d'Ivoire",
            "Croatia",
            "Cuba",
            "Cyprus",
            "Czech Republic",
            "Denmark",
            "Djibouti",
            "Dominica",
            "Dominican Republic",
            "East Timor (Timor-Leste)",
            "Ecuador",
            "Egypt",
            "El Salvador",
            "Equatorial Guinea",
            "Eritrea",
            "Estonia",
            "Eswatini",
            "Ethiopia",
            "Fiji",
            "Finland",
            "France",
            "Gabon",
            "Gambia",
            "Georgia",
            "Germany",
            "Ghana",
            "Greece",
            "Grenada",
            "Guatemala",
            "Guinea",
            "Guinea-Bissau",
            "Guyana",
            "Haiti",
            "Honduras",
            "Hungary",
            "Iceland",
            "India",
            "Indonesia",
            "Iran",
            "Iraq",
            "Ireland",
            "Israel",
            "Italy",
            "Jamaica",
            "Japan",
            "Jordan",
            "Kazakhstan",
            "Kenya",
            "Kiribati",
            "Korea, North",
            "Korea, South",
            "Kosovo",
            "Kuwait",
            "Kyrgyzstan",
            "Laos",
            "Latvia",
            "Lebanon",
            "Lesotho",
            "Liberia",
            "Libya",
            "Liechtenstein",
            "Lithuania",
            "Luxembourg",
            "Madagascar",
            "Malawi",
            "Malaysia",
            "Maldives",
            "Mali",
            "Malta",
            "Marshall Islands",
            "Mauritania",
            "Mauritius",
            "Mexico",
            "Micronesia",
            "Moldova",
            "Monaco",
            "Mongolia",
            "Montenegro",
            "Morocco",
            "Mozambique",
            "Myanmar (Burma)",
            "Namibia",
            "Nauru",
            "Nepal",
            "Netherlands",
            "New Zealand",
            "Nicaragua",
            "Niger",
            "Nigeria",
            "North Macedonia",
            "Norway",
            "Oman",
            "Pakistan",
            "Palau",
            "Palestine",
            "Panama",
            "Papua New Guinea",
            "Paraguay",
            "Peru",
            "Philippines",
            "Poland",
            "Portugal",
            "Qatar",
            "Romania",
            "Russia",
            "Rwanda",
            "Saint Kitts and Nevis",
            "Saint Lucia",
            "Saint Vincent and the Grenadines",
            "Samoa",
            "San Marino",
            "Sao Tome and Principe",
            "Saudi Arabia",
            "Senegal",
            "Serbia",
            "Seychelles",
            "Sierra Leone",
            "Singapore",
            "Slovakia",
            "Slovenia",
            "Solomon Islands",
            "Somalia",
            "South Africa",
            "South Sudan",
            "Spain",
            "Sri Lanka",
            "Sudan",
            "Suriname",
            "Sweden",
            "Switzerland",
            "Syria",
            "Taiwan",
            "Tajikistan",
            "Tanzania",
            "Thailand",
            "Togo",
            "Tonga",
            "Trinidad and Tobago",
            "Tunisia",
            "Turkey",
            "Turkmenistan",
            "Tuvalu",
            "Uganda",
            "Ukraine",
            "United Arab Emirates",
            "United Kingdom",
            "United States",
            "Uruguay",
            "Uzbekistan",
            "Vanuatu",
            "Vatican City",
            "Venezuela",
            "Vietnam",
            "Yemen",
            "Zambia",
            "Zimbabwe",
          ],
          placeholder: "Select a country",
        },
        {
          type: "text",
          name: "currency",
          visible: false,
        },
        {
          type: "text",
          name: "currency",
          title: "What is your local currency?",
          isRequired: true,
          autocomplete: "transaction-currency",
          placeholder: "e.g. USD",
          maxLength: 3,
          validators: [
            {
              type: "regex",
              regex: "^[A-Z]{3}$",
              text: "Please enter a valid 3-letter currency code (e.g. USD, EUR, GBP)",
            },
          ],
        },
      ],
    },
    {
      name: "page7",
      elements: [
        {
          type: "text",
          name: "total_square_footage",
          title: "What is the total square footage (SQFT) of your property, buildings only (excluding outdoor)?",
          description: "To calculate your energy intensity and benchmark against your peers in the dashboard.",
          isRequired: true,
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
            {
              type: "numeric",
              text: "Square footage must be at least 100",
              minValue: 100,
            },
          ],
          inputType: "number",
        },
      ],
    },
    {
      name: "page8",
      elements: [
        {
          type: "html",
          name: "question3",
          html: 'We\'ll need you to download this <a href="#" onclick="window.downloadProcessedExcel && window.downloadProcessedExcel(); return false;" style="text-decoration:none; cursor:pointer;" className="text-primary">spreadsheet</a> and then upload the completed file so that we can set the platform up for you. ',
        },
        {
          type: "file",
          name: "location_consumption",
          title: "Information about your property consumption",
          isRequired: true,
          acceptedTypes: ".xls,.xlsx",
        },
        {
          type: "text",
          name: "energy_tariff",
          title: "What has been your average energy tariff over the past 12 months?",
          description: "Please specify in your local currency per kWh",
          isRequired: true,
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
          ],
          inputType: "number",
        },
        {
          type: "text",
          name: "forecasted_occupancy_rate",
          title: "What is your average forecasted occupancy rate over the next 12 months?",
          isRequired: true,
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
            {
              type: "numeric",
              text: "Percentage must be between 0 and 100",
              minValue: 0,
              maxValue: 100,
            },
          ],
          inputType: "number",
        },
        {
          type: "boolean",
          name: "has_keycard_system",
          title: "Do you have keycard system controlling the AC?",
          isRequired: true,
        },
      ],
    },
    {
      name: "page25",
      elements: [
        {
          type: "text",
          name: "electricity_billing_period_start",
          title: "Electricity Billing Period Start (Day of the Month)",
          description: "e.g. 01",
          isRequired: true,
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
          ],
          min: 1,
          max: 31,
        },
        {
          type: "text",
          name: "electricity_billing_period_end",
          title: "Electricity Billing Period End (Day of the Month)",
          description: "e.g. 30",
          isRequired: true,
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
          ],
          min: 1,
          max: 31,
        },
        {
          type: "text",
          name: "water_billing_period_start",
          title: "Water Billing Period Start (Day of the Month)",
          description: "e.g. 01",
          isRequired: true,
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
          ],
          min: 1,
          max: 31,
        },
        {
          type: "text",
          name: "water_billing_period_end",
          title: "Water Billing Period End (Day of the Month)",
          description: "e.g. 30",
          isRequired: true,
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
          ],
          min: 1,
          max: 31,
        },
        {
          type: "text",
          name: "gas_billing_period_start",
          title: "Gas Billing Period Start (Day of the Month)",
          description: "e.g. 01",
          isRequired: true,
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
          ],
          min: 1,
          max: 31,
        },
        {
          type: "text",
          name: "gas_billing_period_end",
          title: "Gas Billing Period End (Day of the Month)",
          description: "e.g. 30",
          isRequired: true,
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
          ],
          min: 1,
          max: 31,
        },
        {
          type: "text",
          name: "waste_billing_period_start",
          title: "Waste Billing Period Start (Day of the Month)",
          description: "e.g. 01",
          isRequired: true,
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
          ],
          min: 1,
          max: 31,
        },
        {
          type: "text",
          name: "waste_billing_period_end",
          title: "Waste Billing Period End (Day of the Month)",
          description: "e.g. 30",
          isRequired: true,
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
          ],
          min: 1,
          max: 31,
        },
      ],
    },
    {
      name: "page9",
      elements: [
        {
          type: "dropdown",
          name: "hospitality_type",
          title: "What type of hospitality property do you have?",
          isRequired: true,
          choices: ["Hotel", "Resort", "Co-Living", "Serviced Apartments", "Villas", "Hostel"],
          showOtherItem: true,
        },
      ],
    },
    {
      name: "page10",
      elements: [
        {
          type: "text",
          name: "total_guest_rooms",
          title: "Total number of guest rooms",
          description:
            "Up to 80% of a property's consumption comes from guest rooms, so we need to understand how your property is set up.",
          isRequired: true,
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
          ],
        },
        {
          type: "text",
          name: "no_of_studios",
          title: "Number of Studio Rooms",
          description:
            "These would be your room categories that are single, open plan rooms with no separate bedrooms.",
          isRequired: true,
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
          ],
        },
        {
          type: "text",
          name: "no_of_1_bedrooms",
          title: "Number of 1-Bedroom Rooms",
          isRequired: true,
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
          ],
          inputType: "number",
        },
        {
          type: "text",
          name: "no_of_2_bedrooms",
          title: "Number of 2-Bedroom Rooms",
          isRequired: true,
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
          ],
          inputType: "number",
        },
        {
          type: "text",
          name: "no_of_3_bedrooms",
          title: "Number of 3-Bedroom Rooms",
          isRequired: true,
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
          ],
        },
      ],
    },
    {
      name: "page15",
      elements: [
        {
          type: "text",
          name: "rooms_floor_percentage",
          title: "Percentage of floor space covered by rooms",
          description: "This helps us understand your building layout for more accurate estimation.",
          isRequired: true,
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
            {
              type: "numeric",
              text: "Percentage must be between 0 and 100",
              minValue: 0,
              maxValue: 100,
            },
          ],
          inputType: "number",
        },
        {
          type: "text",
          name: "common_areas_floor_percentage",
          title: "Common Areas Floor Percentage",
          description:
            "This includes spaces like lobbies, corridors, and lift lobbies. It does not include restaurants, bars, spa areas, or parking. If you're not sure, you can skip to the next question.",
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
            {
              type: "numeric",
              text: "Percentage must be between 0 and 100",
              minValue: 0,
              maxValue: 100,
            },
          ],
          inputType: "number",
        },
        {
          type: "text",
          name: "restaurants_floor_percentage",
          title: "Restaurants Floor Percentage",
          description:
            "This includes all dining outlets, bars, lounges, and any food and beverage service areas within the property. If you don't know, this, you can skip to the next question.",
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
            {
              type: "numeric",
              text: "Percentage must be between 0 and 100",
              minValue: 0,
              maxValue: 100,
            },
          ],
          inputType: "number",
        },
        {
          type: "text",
          name: "spas_floor_percentage",
          title: "Spa Areas Floor Percentage",
          description:
            "This includes the spa, treatment rooms, relaxation lounges, and wellness facilities (excluding the gym if it's separate). If you don't know, this, you can skip to the next question.",
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
            {
              type: "numeric",
              text: "Percentage must be between 0 and 100",
              minValue: 0,
              maxValue: 100,
            },
          ],
          inputType: "number",
        },
        {
          type: "text",
          name: "back_offices_floor_percentage",
          title: "Back Offices Floor Percentage",
          description:
            "This includes offices for management and staff, storage rooms, and any non-guest-facing operational areas. If you don't know, this, you can skip to the next question.",
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
            {
              type: "numeric",
              text: "Percentage must be between 0 and 100",
              minValue: 0,
              maxValue: 100,
            },
          ],
          inputType: "number",
        },
        {
          type: "text",
          name: "other_areas_floor_percentage",
          title: "Other Areas Floor Percentage",
          description:
            "This could include gyms, function rooms, meeting rooms, parking, or any other spaces not covered above. If you don't know, this, you can skip to the next question.",
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
            {
              type: "numeric",
              text: "Percentage must be between 0 and 100",
              minValue: 0,
              maxValue: 100,
            },
          ],
          inputType: "number",
        },
      ],
    },
    {
      name: "page21",
      elements: [
        {
          type: "multipletext",
          name: "hvac_system_type",
          title: "What percentage of HVAC System(s) does your property use?",
          description:
            "Different types of AC systems consume energy at different rates. By knowing what's installed in your property, we're better able to forecast demand.",
          isRequired: true,
          items: [
            {
              name: "split_unit_percentage",
              title: "Split Unit",
              validators: [
                { type: "numeric", text: "Value must be numeric without special characters" },
                { type: "numeric", text: "Percentage must be between 0 and 100", minValue: 0, maxValue: 100 },
              ],
              inputType: "number",
            },
            {
              name: "vrv_vrf_percentage",
              title: "VRV/VRF",
              validators: [
                { type: "numeric", text: "Value must be numeric without special characters" },
                { type: "numeric", text: "Percentage must be between 0 and 100", minValue: 0, maxValue: 100 },
              ],
              inputType: "number",
            },
            {
              name: "chiller_percentage",
              title: "Chiller",
              validators: [
                { type: "numeric", text: "Value must be numeric without special characters" },
                { type: "numeric", text: "Percentage must be between 0 and 100", minValue: 0, maxValue: 100 },
              ],
              inputType: "number",
            },
            {
              name: "boiler_percentage",
              title: "Boiler",
              validators: [
                { type: "numeric", text: "Value must be numeric without special characters" },
                { type: "numeric", text: "Percentage must be between 0 and 100", minValue: 0, maxValue: 100 },
              ],
              inputType: "number",
            },
          ],
        },
      ],
    },
    {
      name: "page24",
      title: "If you provide submeter readings, please specify the areas tracked.",
      description:
        "Many hotels install submeters to monitor energy use in specific zones such as guest rooms, common areas (lobbies, corridors, meeting rooms), retail and F&B outlets, back-of-house/service areas etc. Skip if not applicable",
      elements: [
        {
          type: "dropdown",
          name: "sub_metered_chiller_reading1",
          title: "Sub-Meter 1/Chiller 1",
          choices: [
            {
              value: "Guest rooms",
              text: "Guest rooms",
              visibleIf:
                "{sub_metered_chiller_reading2} != 'Guest rooms' and {sub_metered_chiller_reading3} != 'Guest rooms' and {sub_metered_chiller_reading4} != 'Guest rooms' and {sub_metered_chiller_reading5} != 'Guest rooms'",
            },
            {
              value: "Common areas",
              text: "Common areas",
              visibleIf:
                "{sub_metered_chiller_reading2} != 'Common areas' and {sub_metered_chiller_reading3} != 'Common areas' and {sub_metered_chiller_reading4} != 'Common areas' and {sub_metered_chiller_reading5} != 'Common areas'",
            },
            {
              value: "Retail/Food and Beverage",
              text: "Retail/Food and Beverage",
              visibleIf:
                "{sub_metered_chiller_reading2} != 'Retail/Food and Beverage' and {sub_metered_chiller_reading3} != 'Retail/Food and Beverage' and {sub_metered_chiller_reading4} != 'Retail/Food and Beverage' and {sub_metered_chiller_reading5} != 'Retail/Food and Beverage'",
            },
            {
              value: "Back-of-office/Service areas",
              text: "Back-of-office/Service areas",
              visibleIf:
                "{sub_metered_chiller_reading2} != 'Back-of-office/Service areas' and {sub_metered_chiller_reading3} != 'Back-of-office/Service areas' and {sub_metered_chiller_reading4} != 'Back-of-office/Service areas' and {sub_metered_chiller_reading5} != 'Back-of-office/Service areas'",
            },
          ],
          placeholder: "Select area",
          showOtherItem: true,
          storeOthersAsComment: false,
        },
        {
          type: "dropdown",
          name: "sub_metered_chiller_reading2",
          title: "Sub-Meter 2/Chiller 2",
          choices: [
            {
              value: "Guest rooms",
              text: "Guest rooms",
              visibleIf:
                "{sub_metered_chiller_reading1} != 'Guest rooms' and {sub_metered_chiller_reading3} != 'Guest rooms' and {sub_metered_chiller_reading4} != 'Guest rooms' and {sub_metered_chiller_reading5} != 'Guest rooms'",
            },
            {
              value: "Common areas",
              text: "Common areas",
              visibleIf:
                "{sub_metered_chiller_reading1} != 'Common areas' and {sub_metered_chiller_reading3} != 'Common areas' and {sub_metered_chiller_reading4} != 'Common areas' and {sub_metered_chiller_reading5} != 'Common areas'",
            },
            {
              value: "Retail/Food and Beverage",
              text: "Retail/Food and Beverage",
              visibleIf:
                "{sub_metered_chiller_reading1} != 'Retail/Food and Beverage' and {sub_metered_chiller_reading3} != 'Retail/Food and Beverage' and {sub_metered_chiller_reading4} != 'Retail/Food and Beverage' and {sub_metered_chiller_reading5} != 'Retail/Food and Beverage'",
            },
            {
              value: "Back-of-office/Service areas",
              text: "Back-of-office/Service areas",
              visibleIf:
                "{sub_metered_chiller_reading1} != 'Back-of-office/Service areas' and {sub_metered_chiller_reading3} != 'Back-of-office/Service areas' and {sub_metered_chiller_reading4} != 'Back-of-office/Service areas' and {sub_metered_chiller_reading5} != 'Back-of-office/Service areas'",
            },
          ],
          placeholder: "Select area",
          showOtherItem: true,
          storeOthersAsComment: false,
        },
        {
          type: "dropdown",
          name: "sub_metered_chiller_reading3",
          title: "Sub-Meter 3/Chiller 3",
          choices: [
            {
              value: "Guest rooms",
              text: "Guest rooms",
              visibleIf:
                "{sub_metered_chiller_reading1} != 'Guest rooms' and {sub_metered_chiller_reading2} != 'Guest rooms' and {sub_metered_chiller_reading4} != 'Guest rooms' and {sub_metered_chiller_reading5} != 'Guest rooms'",
            },
            {
              value: "Common areas",
              text: "Common areas",
              visibleIf:
                "{sub_metered_chiller_reading1} != 'Common areas' and {sub_metered_chiller_reading2} != 'Common areas' and {sub_metered_chiller_reading4} != 'Common areas' and {sub_metered_chiller_reading5} != 'Common areas'",
            },
            {
              value: "Retail/Food and Beverage",
              text: "Retail/Food and Beverage",
              visibleIf:
                "{sub_metered_chiller_reading1} != 'Retail/Food and Beverage' and {sub_metered_chiller_reading2} != 'Retail/Food and Beverage' and {sub_metered_chiller_reading4} != 'Retail/Food and Beverage' and {sub_metered_chiller_reading5} != 'Retail/Food and Beverage'",
            },
            {
              value: "Back-of-office/Service areas",
              text: "Back-of-office/Service areas",
              visibleIf:
                "{sub_metered_chiller_reading1} != 'Back-of-office/Service areas' and {sub_metered_chiller_reading2} != 'Back-of-office/Service areas' and {sub_metered_chiller_reading4} != 'Back-of-office/Service areas' and {sub_metered_chiller_reading5} != 'Back-of-office/Service areas'",
            },
          ],
          placeholder: "Select area",
          showOtherItem: true,
          storeOthersAsComment: false,
        },
        {
          type: "dropdown",
          name: "sub_metered_chiller_reading4",
          title: "Sub-Meter 4/Chiller 4",
          choices: [
            {
              value: "Guest rooms",
              text: "Guest rooms",
              visibleIf:
                "{sub_metered_chiller_reading1} != 'Guest rooms' and {sub_metered_chiller_reading2} != 'Guest rooms' and {sub_metered_chiller_reading3} != 'Guest rooms' and {sub_metered_chiller_reading5} != 'Guest rooms'",
            },
            {
              value: "Common areas",
              text: "Common areas",
              visibleIf:
                "{sub_metered_chiller_reading1} != 'Common areas' and {sub_metered_chiller_reading2} != 'Common areas' and {sub_metered_chiller_reading3} != 'Common areas' and {sub_metered_chiller_reading5} != 'Common areas'",
            },
            {
              value: "Retail/Food and Beverage",
              text: "Retail/Food and Beverage",
              visibleIf:
                "{sub_metered_chiller_reading1} != 'Retail/Food and Beverage' and {sub_metered_chiller_reading2} != 'Retail/Food and Beverage' and {sub_metered_chiller_reading3} != 'Retail/Food and Beverage' and {sub_metered_chiller_reading5} != 'Retail/Food and Beverage'",
            },
            {
              value: "Back-of-office/Service areas",
              text: "Back-of-office/Service areas",
              visibleIf:
                "{sub_metered_chiller_reading1} != 'Back-of-office/Service areas' and {sub_metered_chiller_reading2} != 'Back-of-office/Service areas' and {sub_metered_chiller_reading3} != 'Back-of-office/Service areas' and {sub_metered_chiller_reading5} != 'Back-of-office/Service areas'",
            },
          ],
          placeholder: "Select area",
          showOtherItem: true,
          storeOthersAsComment: false,
        },
        {
          type: "dropdown",
          name: "sub_metered_chiller_reading5",
          title: "Sub-Meter 5/Chiller 5",
          choices: [
            {
              value: "Guest rooms",
              text: "Guest rooms",
              visibleIf:
                "{sub_metered_chiller_reading1} != 'Guest rooms' and {sub_metered_chiller_reading2} != 'Guest rooms' and {sub_metered_chiller_reading3} != 'Guest rooms' and {sub_metered_chiller_reading4} != 'Guest rooms'",
            },
            {
              value: "Common areas",
              text: "Common areas",
              visibleIf:
                "{sub_metered_chiller_reading1} != 'Common areas' and {sub_metered_chiller_reading2} != 'Common areas' and {sub_metered_chiller_reading3} != 'Common areas' and {sub_metered_chiller_reading4} != 'Common areas'",
            },
            {
              value: "Retail/Food and Beverage",
              text: "Retail/Food and Beverage",
              visibleIf:
                "{sub_metered_chiller_reading1} != 'Retail/Food and Beverage' and {sub_metered_chiller_reading2} != 'Retail/Food and Beverage' and {sub_metered_chiller_reading3} != 'Retail/Food and Beverage' and {sub_metered_chiller_reading4} != 'Retail/Food and Beverage'",
            },
            {
              value: "Back-of-office/Service areas",
              text: "Back-of-office/Service areas",
              visibleIf:
                "{sub_metered_chiller_reading1} != 'Back-of-office/Service areas' and {sub_metered_chiller_reading2} != 'Back-of-office/Service areas' and {sub_metered_chiller_reading3} != 'Back-of-office/Service areas' and {sub_metered_chiller_reading4} != 'Back-of-office/Service areas'",
            },
          ],
          placeholder: "Select area",
          showOtherItem: true,
          storeOthersAsComment: false,
        },
      ],
    },
    {
      name: "page23",
      elements: [
        {
          type: "text",
          name: "hvac_consumption_percentage",
          title: "What percentage of your energy consumption comes from HVAC?",
          description:
            "This helps us understand your consumption better so we can model things more accurately. If you don't know this, you can skip the question, and we will use the averages from the properties we already work with.",
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
            {
              type: "numeric",
              text: "Percentage must be between 0 and 100",
              minValue: 0,
              maxValue: 100,
            },
          ],
          inputType: "number",
        },
      ],
    },
    {
      name: "page22",
      elements: [
        {
          type: "radiogroup",
          name: "laundry_processed",
          title: "Where is your laundry processed?",
          isRequired: true,
          choices: [
            {
              value: "in_hotel",
              text: "In hotel premise",
            },
            {
              value: "external",
              text: "Outsource to external provider",
            },
          ],
        },
        {
          type: "boolean",
          name: "has_solar_energy_system_installed",
          title: " Do you have a solar energy system installed on the property?",
          isRequired: true,
        },
        {
          type: "text",
          name: "solar_energy_installation_date",
          title: " If yes, when did you install the system? (Month/Year)",
          description: "Please enter in MM/YYYY format. Skip if not applicable",
          placeHolder: "MM/YYYY",
          validators: [
            {
              type: "regex",
              text: "Please enter a valid month/year in MM/YYYY format (e.g., 01/2024)",
              regex: "^(0[1-9]|1[0-2])/(19|20)\\d{2}$",
            },
          ],
          onValueChanged(sender: { value: string }, options: { value: string }) {
            if (options.value) {
              const [month, year] = options.value.split("/");
              const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, 1);
              return date.toISOString().split("T")[0];
            }
            return null;
          },
        },
        {
          type: "text",
          name: "solar_energy_percentage",
          title: "Approximately what percentage of your total energy usage is covered by solar generation? ",
          description: "Skip if not applicable",
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
            {
              type: "numeric",
              text: "Percentage must be between 0 and 100",
              minValue: 0,
              maxValue: 100,
            },
          ],
          inputType: "number",
        },
        {
          type: "radiogroup",
          name: "gas_type",
          title: "What type of gas is primarily used on your property?",
          isRequired: true,
          choices: [
            {
              value: "natural_gas",
              text: "Natural Gas",
            },
            {
              value: "lpg",
              text: "LPG (Liquefied Petroleum Gas)",
            },
            {
              value: "not_applicable",
              text: "Not applicable / No gas used",
            },
          ],
        },
        {
          type: "tagbox",
          name: "gas_usage",
          title: "What is the gas mainly used for? (Select all that apply)",
          choices: [
            {
              value: "water_heating",
              text: "Water heating",
            },
            {
              value: "cooking",
              text: "Cooking",
            },
            {
              value: "laundry_equipment",
              text: "Laundry equipment",
            },
          ],
          showOtherItem: true,
        },
        {
          type: "text",
          name: "other_renewable_energy_consumption_percentage",
          title: "What percentage of your total energy consumption comes from sustainable or renewable sources?",
          description: "Skip if not applicable",
          validators: [
            {
              type: "numeric",
              text: "Value must be numeric without special characters",
            },
            {
              type: "numeric",
              text: "Percentage must be between 0 and 100",
              minValue: 0,
              maxValue: 100,
            },
          ],
          inputType: "number",
        },
        {
          type: "boolean",
          name: "has_major_bms_energy_equipment_change",
          title:
            "In the past 12 months, have you made any major changes to your building systems or energy-related equipment?",
          isRequired: true,
        },
        {
          type: "boolean",
          name: "has_energy_initiatives",
          title: "Any other energy reduction or sustainability initiatives on the property? ",
          description:
            "HVAC management is only one part of your sustainability plans, please let us know about the other things you do to be more green!",
        },
        {
          type: "comment",
          name: "energy_initiatives",
          title: "If yes, please specify.",
        },
      ],
    },
  ],
  partialSendEnabled: true,
  navigateToUrlOnCondition: [{}],
  showProgressBar: true,
};

export default json;
